import { getConfig } from 'app/env';
import __ from 'core/lib/localization';
import { Story } from 'core/models/story-manager';

const makeUrl = (params: any) => {
  const { btoa } = window;
  const id = btoa(btoa(JSON.stringify(params)));
  return `${getConfig(
    'website.urls.jwPressServer'
  )}/api/listening-guide?request_id=${id}`;
};

export type DownloadableResource = {
  label: string;
  description: string;
  url: string;
  restricted?: boolean;
};

export function getResources(
  story: Story,
  email: string
): DownloadableResource[] {
  const { slug } = story;

  const resources: DownloadableResource[] = [];

  const guidedListeningLabel = __(
    'Guided listening worksheet',
    'classroom.guidedListeningWorkSheet'
  );

  resources.push({
    label: __('Basic story script', 'classrooms.basicStoryScript'),
    description: __(
      'Story transcript and translation, side by side',
      'classroom.storyTranscriptAndTranslation'
    ),
    url: `/scripts/basic/${story.slug}`,
    restricted: false,
  });

  resources.push({
    label: __('Scaffolded story script', 'classrooms.scaffoldedStoryScript'),
    description: __(
      'Fully annotated by chapter with vocabulary, hints, and notes',
      'classroom.fullyAnnotatedByChapter'
    ),
    url: `/scripts/${story.slug}`,
  });

  resources.push({
    label: `${guidedListeningLabel} (${__('PDF', 'classroom.pdf')})`,
    description: __('Print out for writing notes', 'classroom.printOutFor'),
    url: makeUrl({ slug, email }),
  });

  resources.push({
    label: `${guidedListeningLabel} (${__('RTF', 'classroom.digital')})`,
    description: __(
      'Open in Word or Google Docs for typing notes',
      'classroom.openInWordOr'
    ),
    url: makeUrl({ slug, email, format: 'rtf' }),
  });

  return resources;
}
